// extracted by mini-css-extract-plugin
module.exports = {"ReviewModal":"A5qjOKMdzGEqqj0zM5iW2"};